import React from 'react';
import { useDispatch } from 'react-redux';
import { updateSelectedImages } from '.';

export default function useUpdateSelectedImages() {
  const dispatch = useDispatch();
  return React.useCallback(payload => dispatch(updateSelectedImages(payload)), [dispatch]);
}